export const velocityRebelPortfolioItem = {
  id: 'fallback-velocity-rebel',
  title: 'Velocity Rebel',
  description: 'No rules, just the road. Cruise in chrome, tour the distance or chase the fastest line across six distinct machines. Double-tap for an auto-lock EMP that disables cars, rivals and patrol bikes, with three lives and 5 km checkpoints.',
  category: 'Games',
  subcategory: 'Open-Road Racing',
  type: 'browser-game',
  url: 'https://velocityrebel.netlify.app/',
  featured: 'TRUE',
  order: -1
};